import {
	CommerceTableParams,
	ResponseTableCommerce,
	SetCreateMerchantParams,
	SetMerchantActive,
} from '../models/commerce';
import { CommonTableParams } from '../models/common-payments';
import { client } from '../utils/api';
import { tableParamsConstructor } from '../utils/common';

const getTableData = async ({ ...rest }: CommonTableParams) => {
	try {
		const params = tableParamsConstructor(rest);
		const { data } = await client.get<ResponseTableCommerce>('/v1/operational/common/merchant', {
			params,
		});
		return data;
	} catch (error: any) {
		throw error.response.data;
	}
};

const getTableDataEnterprise = async ({ ...rest }: CommerceTableParams) => {
	try {
		const params = rest;
		const { data } = await client.get<ResponseTableCommerce>('/v1/operational/common/merchant', {
			params,
		});
		return data;
	} catch (error: any) {
		throw error.response.data;
	}
};

const setMerchantActive = async ({ merchant_code, ...resp }: SetMerchantActive) => {
	try {
		const body = resp;
		const { data } = await client.put('/v1/operational/common/merchant', body, {
			params: { merchant_code },
		});

		return data;
	} catch (error: any) {
		throw error.response.data;
	}
};

const setCreateMerchant = async ({ operation, ...resp }: SetCreateMerchantParams) => {
	try {
		const body = resp.data;

		const { data } = await client.post('/v1/operational/common/create-merchant', body, {
			params: { operation },
		});

		return data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const CommerceServices = {
	getTableData,
	setCreateMerchant,
	setMerchantActive,
	getTableDataEnterprise,
};
